import { BaseController } from "@/shared/logic/controller";
import { InscriptionSimple } from "@/shared/logic/types";
import axios from "axios";
import { Inscriptions } from "@/shared/logic/api";
import { parsePreselected, apiUrl } from "../shared";

const preselected = parsePreselected();

export class Controller extends BaseController {
  async envoiInscription(insc: InscriptionSimple) {
    try {
      await axios.post(apiUrl(Inscriptions.EnregistreInscriptionSimple), insc, {
        params: { preselected }
      });
      return true;
    } catch (error) {
      this.notifications.onAxiosError(error);
    }
  }
}

export const C = new Controller();
